import React, { useState } from 'react';
import './index.css';

// Components
import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import AboutSection from './components/AboutSection';
import ShowcaseSection from './components/ShowcaseSection';
import ServicesSection from './components/ServicesSection';
import InteractiveDemoSection from './components/InteractiveDemoSection';
import PricingPlansSection from './components/PricingPlansSection';
import ProjectsSection from './components/ProjectsSection';
import ContactSection from './components/ContactSection';
import Footer from './components/Footer';
import AuthModal from './components/AuthModal';
import WhatsAppWidget from './components/WhatsAppWidget';

function App() {
  const [showAuthModal, setShowAuthModal] = useState(false);
  const [authMode, setAuthMode] = useState('login'); // 'login' or 'register'

  const handleLoginClick = () => {
    setAuthMode('login');
    setShowAuthModal(true);
  };

  const handleRegisterClick = () => {
    setAuthMode('register');
    setShowAuthModal(true);
  };

  const handleSwitchMode = () => {
    setAuthMode(authMode === 'login' ? 'register' : 'login');
  };

  const handleGetStarted = () => {
    // Check if user is logged in
    const token = localStorage.getItem('token');
    if (token) {
      // Scroll to contact section
      document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' });
    } else {
      // Show register modal
      handleRegisterClick();
    }
  };

  return (
    <div className="App min-h-screen bg-[#0a0e27]">
      {/* Navigation */}
      <Navbar onLoginClick={handleLoginClick} onRegisterClick={handleRegisterClick} />

      {/* Main Content */}
      <main>
        <HeroSection onGetStarted={handleGetStarted} />
        <AboutSection />
        <ShowcaseSection />
        <ServicesSection />
        <InteractiveDemoSection />
        <PricingPlansSection />
        <ProjectsSection />
        <ContactSection />
      </main>

      {/* Footer */}
      <Footer />

      {/* Auth Modal */}
      <AuthModal
        isOpen={showAuthModal}
        onClose={() => setShowAuthModal(false)}
        mode={authMode}
        onSwitchMode={handleSwitchMode}
      />

      {/* WhatsApp Widget */}
      <WhatsAppWidget />
    </div>
  );
}

export default App;
